

import { Component, Prop, Vue } from "vue-property-decorator"

// @ts-ignore
import { InsightDetails } from "@/types/insights"

@Component({
	components: {
	}
})
export default class InsightDeleteModal extends Vue {
	@Prop() insightToDelete!: InsightDetails | null

	private deleteConfirmText: string | null = null;

	private get canDeleteInsight (): boolean {
		return !!this.insightToDelete
	}

	private get isOpen (): boolean {
		return !!this.insightToDelete
	}

	private set isOpen (opened: boolean) {
		if (!opened) {
			this.close()
		}
	}

	public deleteInsight () {
		if (this.insightToDelete) {
			this.$emit("deleteConfirmed")

			this.deleteConfirmText = null
		}
	}

	public close () {
		this.deleteConfirmText = null

		this.$emit("close")
	}
}
